import React, { FC, useEffect, useState } from 'react'
import { Redirect, useLocation, Switch } from 'react-router-dom'
import { Cache } from 'aws-amplify'
import { useUpdateEffect } from 'react-use'

// Components
import { Loader } from 'components/shared'

// Helpers
import { EventConfig, EventStages, IUser } from 'types'
import { graphQLMutation, graphQLQuery } from 'graphql/helpers'
import { userByEmailBase } from 'graphql/customQueries'
import { useAppState } from 'providers'
import { tokenName } from 'helpers'
import { updateUser } from 'graphql/mutations'

interface UserAuthenticatedRoutesProps {
  children?: React.ReactNode
  eventConfig: EventConfig
}

export const UserAuthenticatedRoutes: FC<UserAuthenticatedRoutesProps> = ({ children, eventConfig }) => {
  const location = useLocation()
  const {
    setUser,
    appState: { user }
  } = useAppState()
  const [loading, setLoading] = useState<boolean>(true)

  const updateUserLogin = (id: string) => {
    const lastLogin = new Date().toISOString()
    graphQLMutation(updateUser, { id, lastLogin })
  }

  const nullifyUser = () => {
    setUser(null)
    setLoading(false)
  }

  const checkUser = async () => {
    try {
      const { email } = await Cache.getItem(tokenName)
      let foundUser
      let userId = user?.id
      if (email) {
        if (!userId) {
          foundUser = await graphQLQuery(userByEmailBase, 'userByEmail', {
            email
          })
          setUser(foundUser as IUser)
          userId = foundUser?.id
        }

        if (userId) {
          if (location.pathname === '/event' && location.state && (location.state as object)['referrer']) {
            location.state = {}
            return
          } else {
            updateUserLogin(userId)
          }

          if (eventConfig?.stage) {
            setLoading(false)
          }
        } else {
          nullifyUser()
        }
      } else {
        nullifyUser()
      }
    } catch (err) {
      nullifyUser()
    }
  }

  useEffect(() => {
    checkUser()
    // eslint-disable-next-line
  }, [location])

  useUpdateEffect(() => {
    setLoading(false)
  }, [eventConfig])

  //return <>{children}</>
  return eventConfig?.stage &&
    (eventConfig?.stage !== EventStages.REGISTRATION || user?.email?.includes('@mvrk.co')) &&
    user &&
    !loading ? (
    <Switch>{children}</Switch>
  ) : loading ? (
    <Loader />
  ) : (
    <Redirect to='/' />
  )
}
